import React from 'react';
import { disableDemoMode, isDemoMode } from './index';

/**
 * Thin persistent indicator shown while the app runs in demo mode.
 * Fixed to the bottom so it never collides with the app's top nav.
 */
const DemoBanner: React.FC = () => {
  if (!isDemoMode()) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 12,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        padding: '0.5rem 0.9rem',
        borderRadius: 999,
        background: 'rgba(11,42,74,0.96)',
        color: '#fff',
        boxShadow: '0 8px 24px rgba(0,0,0,0.28)',
        fontSize: '0.82rem',
        fontWeight: 600,
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        backdropFilter: 'blur(8px)',
      }}
    >
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: '#f5b301',
          boxShadow: '0 0 0 0 rgba(245,179,1,0.7)',
          animation: 'etraxPulse 2s infinite',
        }}
      />
      <span>Live Demo — sample data · changes reset on reload</span>
      <button
        onClick={disableDemoMode}
        style={{
          marginLeft: 4,
          padding: '0.2rem 0.6rem',
          borderRadius: 999,
          border: '1px solid rgba(255,255,255,0.35)',
          background: 'transparent',
          color: '#fff',
          fontSize: '0.75rem',
          fontWeight: 700,
          cursor: 'pointer',
        }}
      >
        Exit
      </button>
      <style>{`@keyframes etraxPulse {0%{box-shadow:0 0 0 0 rgba(245,179,1,0.6);}70%{box-shadow:0 0 0 7px rgba(245,179,1,0);}100%{box-shadow:0 0 0 0 rgba(245,179,1,0);}}`}</style>
    </div>
  );
};

export default DemoBanner;
